import React, { useContext, useState, useEffect } from 'react';
import { Context } from '../../defaults';
import { Descriptions, Space, Empty, Tag, Select } from 'antd';
import {
  getRegisteredStudentsCountByInstitutionId,
  getInstitutionById,
  getInstitutionsType,
  getPaymentsTypes,
  getInstitutions,
} from '../../actions';
import jwtDecode from 'jwt-decode';

const General = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [institutions, setInstitutions] = useState([]);
  const [userRole, setUserRole] = useState('');
  const [selectedInstitution, setSelectedInstitution] = useState('');
  const [institutionsType, setInstitutionsType] = useState([]);
  const [paymentTypes, setPaymentsTypes] = useState([]);
  const [lessStudentsCount, setLessStudentsCount] = useState(0);
  const [lessStudentsColor, setLessStudentsColor] = useState('');
  const [registeredStudentsCount, setRegisteredStudentsCount] = useState(0);

  const onStart = () => {
    const persistedToken = jwtDecode(localStorage['token']);
    setUserRole(persistedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']);
  };

  useEffect(() => {
    setLoading(true);
    !!localStorage['token'] && onStart();
    getInstitutions().then(({ data }) => setInstitutions(data));
    getInstitutionsType().then(({ data }) => setInstitutionsType(data));
    getPaymentsTypes().then(({ data }) => setPaymentsTypes(data));
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    const count = selectedInstitution.studentsCount - registeredStudentsCount;
    setLessStudentsCount(count.toString());
    if (count === 0) setLessStudentsColor('green');
    else if (count > selectedInstitution.studentsCount * 0.5) setLessStudentsColor('green');
    else if (count > selectedInstitution.studentsCount * 0.2) setLessStudentsColor('orange');
    else setLessStudentsColor('red');
    setLoading(false);
  }, [registeredStudentsCount]);

  const onChangeInstitute = (e, { value }) => {
    if (value) {
      getInstitutionById(value).then((res) => setSelectedInstitution(res.data));
      getRegisteredStudentsCountByInstitutionId(value).then(({ data }) =>
        setRegisteredStudentsCount(parseInt(data)),
      );
    }
  };

  return (
    <React.Fragment>
      <Space direction="vertical" size="middle" style={{ marginTop: '3em', width: '100%' }}>
        {userRole && institutions.length > 1 && (
          <Select
            placeholder={dictionary?.NameOfInstitution[language]}
            allowClear
            onChange={onChangeInstitute}
            showSearch
            size="large"
            style={{ width: '100%' }}
            filterOption={(input, option) => {
              return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}>
            {!!institutions &&
              institutions.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        )}

        {selectedInstitution ? (
          <Descriptions bordered column={3}>
            <Descriptions.Item label={dictionary?.NameOfInstitution[language]}>
              {selectedInstitution.name}
            </Descriptions.Item>
            <Descriptions.Item label={dictionary?.TypeOfInstitution[language]} span={2}>
              {
                institutionsType.filter((el) => el.id === selectedInstitution.institutionTypeId)[0]
                  ?.name
              }
            </Descriptions.Item>
            <Descriptions.Item label={dictionary?.PaymentType[language]} span={3}>
              {
                paymentTypes?.filter((x) => x.id === selectedInstitution.paymentTypeId)[0][
                  `${language}Description`
                ]
              }
            </Descriptions.Item>
            {selectedInstitution.paymentTypeId === 2 && (
              <>
                <Descriptions.Item label={dictionary?.NumberOfContractStudents[language]} span={3}>
                  {selectedInstitution.studentsCount}
                </Descriptions.Item>
                <Descriptions.Item
                  label={dictionary?.NumberOfRegisteredStudents[language]}
                  span={3}>
                  <Tag color="blue">{registeredStudentsCount}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.NumberOfRemainingStudents[language]} span={3}>
                  <Tag color={lessStudentsColor}>{lessStudentsCount}</Tag>
                </Descriptions.Item>
              </>
            )}
          </Descriptions>
        ) : (
          <Empty style={{ marginTop: '100px' }} />
        )}
      </Space>
    </React.Fragment>
  );
};

export default General;
